import { Box, Stack, Typography } from "@mui/material"
import { styles } from "./styles/TeensLicenseModal.styles"

export default function FeatureItem({
  icon,
  title,
  description,
  iconBgColor,
  sx,
}) {
  return (
    <Stack position={"relative"} sx={sx}>
      <Box sx={styles.featureItem}>
        <Box
          sx={[
            styles.featureIconWrapper,
            iconBgColor && { backgroundColor: iconBgColor },
          ]}
        >
          <Box
            component="img"
            src={icon || require("assets/img/licenses/icono5.png")}
            alt="icon"
            sx={styles.icon}
          />
        </Box>
        <Box sx={{ textAlign: "left" }}>
          <Typography sx={styles.featureTitle}>{title}</Typography>
          <Typography sx={styles.featureDesc}>{description}</Typography>
        </Box>
      </Box>
    </Stack>
  )
}
